import { createFileRoute } from '@tanstack/react-router';
import { InfoPage } from '../components/InfoPage.js';

export const Route = createFileRoute('/privacy-policy')({
  component: () => <InfoPage title="Privacy Policy" />,
});
